import { render, staticRenderFns } from "./VSMSReportMenu.vue?vue&type=template&id=642ffff0&scoped=true&"
import script from "./VSMSReportMenu.vue?vue&type=script&lang=js&"
export * from "./VSMSReportMenu.vue?vue&type=script&lang=js&"
import style0 from "./VSMSReportMenu.vue?vue&type=style&index=0&id=642ffff0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ffff0",
  null
  
)

export default component.exports